<div class="edit-carrier-package-wrapper" #carrierWrapper>
  <div class="input-wrapper" [formGroup]="settingsEditPackageService.formGroup">
    <pdq-input
      formControlName="name"
      type="text"
      label="Package name"
      [withIcon]="false"
      [autofocus]="false"
      placeholder="Enter package name"
      variant="form"
      background="default"
      [border]="true"
      [autocompleteMode]="false"
      showBrowserAutocomplete="off"
      width="707">
    </pdq-input>
  </div>
  <div class="binding input-wrapper">
    <div class="binding__title"><p>Shortcut key (optional)</p></div>
    <div class="binding__content">
      <key-bind-dropdown
        [formControl]="settingsEditPackageService.formGroup.get('keybind')"
        [unavailableKeyBinds]="unavailableKeyBinds"></key-bind-dropdown>
    </div>
  </div>
  <div class="carriers-wrapper">
    @for (carrier of carrierData; track carrier) {
      <div class="carrier-wrapper" [ngClass]="{ open: carrier.open }">
        <div class="carrier-item">
          <pdq-icon
            [icon]="carrier.open ? 'large_toggle_arrow' : 'side_right_arrow'"
            (click)="toggleDisplayCarrierData(carrier)"></pdq-icon>
          <img [src]="carrier.icon" alt="" />
          <div class="name">{{ carrier.name | uppercase }}</div>
        </div>
        @if (carrier.open) {
          <div>
            @for (package of carrier.packages; track package) {
              <div
                class="package-item"
                (click)="selectPackage(package)"
                [ngClass]="{ selected: package.id === selectedCarrierPackage?.id }">
                <app-settings-package-details [package]="package" [isCarrier]="true"> </app-settings-package-details>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div>
    @if (selectedCarrierPackage) {
      <app-settings-package-condition [rules]="boxData?.rules"> </app-settings-package-condition>
    }
  </div>
  <footer
    [ngClass]="
      !settingsEditPackageService.formGroup.dirty && (!selectedCarrierPackage || boxData) ? 'initial' : 'apear'
    ">
    <span>You have unsaved changes</span>
    <pdq-button variant="secondary" (click)="resetForm()" [disabled]="isLoading" label="cancel" class="action-btn"
      >Cancel</pdq-button
    >
    <pdq-button
      variant="primary"
      type="submit"
      label="save"
      class="action-btn"
      (click)="onSubmit()"
      [loading]="isLoading"
      >Save
    </pdq-button>
  </footer>
</div>
